module.exports = __webpack_public_path__ + "img/reservatorio.a5ad2301.png";